import { createStore } from 'vuex';

let colorScheme;
if (process.env.VUE_APP_STYLE === 'bvs') {
  colorScheme = [
    '#cebca9',
    '#bba389',
    '#a98a68',
    '#8d7151',
    '#6d573e',
    '#423e26',
    '#796732',
    '#bfa863',
    '#d8ca9f',
    '#e2d7b7',
    '#ebe4cf',
    '#faf8f3',
  ];
} else if (process.env.VUE_APP_STYLE === 'ox') {
  colorScheme = [
    '#b4eccd',
    '#8be2b2',
    '#55d48e',
    '#2eb76c',
    '#21814c',
    '#165834',
    '#0c2f1c',
    '#21816b',
    '#2eb799',
    '#55d4b8',
    '#8be2cf',
    '#b4ece0',
  ];
} else if (process.env.VUE_APP_STYLE === 'db') {
  colorScheme = [
    '#A8F26F',
    '#8FE646',
    '#79D921',
    '#66cc00',
    '#40BF06',
    '#21B30B',
    '#10A618',
    '#139934',
  ];
} else {
  colorScheme = [
    '#009efa',
    '#0073b6',
    '#005e94',
    '#004872',
    '#002f61',
    '#004794',
    '#0060c7',
    '#0078fa',
    '#2e93ff',
    '#61adff',
    '#94c7ff',
    '#c7e2ff',
  ];
}

const state = {
  client: null,
  role: 0,
  name: '',
  twoFactor: false,
  unread: [],
  ports: null,
  intakes: [],
  mandates: [],
  intake: {},
  overview: {},
  errors: {},
  showstoppersErrors: {},
  showstoppers: {},
  cdderrors: {},
  nps: null,
  openPassword: false,
  openTwofactor: false,
  intakeValidate: false,
  currentView: 'Login',
  currentPort: null,
  currentBank: null,
  currentPortGrouping: 'new_class',
  currentTransGrouping: 'Alles',
  activityUserId: null,
  colorScheme,
  cdd: {},
  confirm: {
    display: false,
    toggle(obj) {
      if ((obj === undefined) || (obj.text === undefined) || (obj.cb === undefined)) {
        return;
      }

      this.alert = obj.alert !== undefined && obj.alert === true ? obj.alert : false;

      if (this.alert && (obj.title === undefined || obj.title === '')) {
        this.title = 'Melding';
      } else {
        this.title = obj.title || 'Waarschuwing';
      }

      if (this.alert && (obj.confirmText === undefined || obj.confirmText === '')) {
        this.confirmText = 'OK';
      } else {
        this.confirmText = obj.confirmText || 'Doorgaan';
      }

      this.display = true;
      this.text = obj.text;
      this.cb = obj.cb;
      this.cancelText = obj.cancelText || 'Terug';
    },
  },
};
export const store = createStore({
  state,
});
